import { lazy } from "react"

export const FinanceDataFromMailboxPage = lazy(() => import("./FinanceDataFromMailboxPage"))